import { ScrapedProductFilters } from "@/types/scraped-product";

export const SCRAPED_PRODUCT_KEY = "SCRAPED_PRODUCT";

export const SCRAPED_PRODUCT_CACHE_KEY = {
  LIST: (filters: ScrapedProductFilters) =>
    [SCRAPED_PRODUCT_KEY, "LIST", filters] as const,
};
